import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Permission: 'Permission',
      Common: 'Common',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      SETOPTIONS: 'Permission/SETOPTIONS',
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
      setSearchData_M:"Permission/setSearchData_M"
    }),
    ...mapActions({
      getTableList_A:"Permission/getTableList_A",
      getUnitType_A:"Permission/getUnitType_A",
      getPmsList_A:"Permission/getPmsList_A",
      createEditPms_A:"Permission/createEditPms_A"
      
    })

  }

}




// WEBPACK FOOTER //
// ./src/pages/PartI/PermissionPackage/components/Mixins.js